import bulkInvoiceItemTypesUpload from "./bulkInvoiceItemTypesUpload.component";
import bulkInvoiceItemTypesUploadUrls from "./bulkInvoiceItemTypesUpload.urls";
import BulkInvoiceItemTypesUploadTransforms from "./bulkInvoiceItemTypesUpload.transforms";

const bulkInvoiceItemTypesUploadModule = angular
  .module("app.components.bulkInvoiceItemTypesUpload", [])
  .component("bulkInvoiceItemTypesUploadPage", bulkInvoiceItemTypesUpload)
  .service(
    "BulkInvoiceItemTypesUploadTransforms",
    BulkInvoiceItemTypesUploadTransforms
  )
  .config(bulkInvoiceItemTypesUploadUrls);

export default bulkInvoiceItemTypesUploadModule;



// WEBPACK FOOTER //
// ./src/pages/bulkInvoiceItemTypesUpload/bulkInvoiceItemTypesUpload.module.js